import { get } from 'lodash'
import { createHorizontalTimelineSelector as createSelector } from '../selectors'
import type { HorizontalTimelineState } from '../reducers/index'
import { getHorizontalVizBase } from './general_selectors'

export const stageSizeSelector = function (state: HorizontalTimelineState, _props: any) {
  // Note: Could be undefined if not yet initialized
  const slice = getHorizontalVizBase(state)
  return get(slice, ['size'])
}

export const stageWidthSelector = createSelector(stageSizeSelector, function (stageSize) {
  return get(stageSize, ['width'])
})
export const stageHeightSelector = createSelector(stageSizeSelector, function (stageSize) {
  return get(stageSize, ['height'])
})
